import { render, staticRenderFns } from "./ProductsSidebar.vue?vue&type=template&id=4fcaa7c0&scoped=true"
import script from "./ProductsSidebar.vue?vue&type=script&lang=js"
export * from "./ProductsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductsSidebar.vue?vue&type=style&index=0&id=4fcaa7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcaa7c0",
  null
  
)

export default component.exports